.itemDragging {
  background-color: var(--white);
}

.draggingList {
  border: 1px solid var(--blue);
}
